import BaseStore from 'fluxible/addons/BaseStore';
import { each } from 'lodash';

class ApplicationStore extends BaseStore {
  constructor(dispatcher) {
    super(dispatcher);
    this.flags = {};
    this.state = { isStickyHeaderVisible: false };
    this.pageTitle = '';
    this.pageDescription = '';
    this.domainUrlApp = '';
    this.dashboardUrl = '';
    this.domainUrlDocs = '';
    this.domainUrlSignup = '';
  }

  isMobile() {
    return this.flags.mobile;
  }

  isFramedMode() {
    return !!this.flags.framed;
  }

  getPreferredColorScheme() {
    return this.flags.preferredColorScheme;
  }

  getTheme() {
    return this.flags.theme || 'light';
  }

  isSingleQuickstartMode() {
    return !!this.flags.singleQuickstart;
  }

  isStickyHeaderVisible() {
    return !!this.state.isStickyHeaderVisible;
  }

  getPageTitle() {
    return this.pageTitle;
  }

  getPageDescription() {
    return this.pageDescription;
  }

  getDomainUrlApp() {
    return this.domainUrlApp;
  }

  getDashboardUrl() {
    return this.dashboardUrl;
  }

  getDashboardClientsUrl() {
    return `${this.getDashboardUrl()}/applications`;
  }

  getDashboardApisUrl() {
    return `${this.getDashboardUrl()}/apis`;
  }

  getDomainUrlSignup() {
    return this.domainUrlSignup;
  }

  getDomainUrlDocs() {
    return this.domainUrlDocs;
  }

  handleModeFlagsLoaded(payload) {
    this.flags = payload.flags;
    this.emitChange();
  }

  handlePageMetadata(payload) {
    this.pageTitle = payload.pageTitle;
    this.pageDescription = payload.pageDescription;
    this.emitChange();
  }

  handleEnvVariablesLoaded(payload) {
    each(payload, (value, key) => {
      this[key] = value;
    });

    this.emitChange();
  }

  handleStickyHeaderVisibilityUpdate(payload) {
    this.state.isStickyHeaderVisible = payload.isStickyHeaderVisible;
    this.emitChange();
  }

  dehydrate() {
    return {
      flags: this.flags,
      state: this.state,
      pageTitle: this.pageTitle,
      pageDescription: this.pageDescription,
      domainUrlApp: this.domainUrlApp,
      dashboardUrl: this.dashboardUrl,
      domainUrlDocs: this.domainUrlDocs,
      domainUrlSignup: this.domainUrlSignup,
    };
  }

  rehydrate(state) {
    this.flags = state.flags;
    this.state = state.state;
    this.pageTitle = state.pageTitle;
    this.pageDescription = state.pageDescription;
    this.domainUrlApp = state.domainUrlApp;
    this.dashboardUrl = state.dashboardUrl;
    this.domainUrlDocs = state.domainUrlDocs;
    this.domainUrlSignup = state.domainUrlSignup;
  }
}

ApplicationStore.storeName = 'ApplicationStore';
ApplicationStore.handlers = {
  MODE_FLAGS_LOADED: 'handleModeFlagsLoaded',
  UPDATE_PAGE_METADATA: 'handlePageMetadata',
  LOAD_ENV_VARIABLES: 'handleEnvVariablesLoaded',
  UPDATE_STICKY_HEADER_VISIBILITY: 'handleStickyHeaderVisibilityUpdate',
};

export default ApplicationStore;
